import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  activeStepProducts: 0,
  cartProducts: [],
  subtotalProducts: 0,
  totalProducts: 0,
  utilityTotal: 0,
  utilityDag: 0,
  utilityLicen: 0,
  discountProducts: 0,
  almacenId: '',
  //
  // subtotalServ: 0,
  // subtotalRec: 0,
  //
  billing: null,

  itemApproved: null,

  itemsSuccess: [],
  itemsError: []
};

const slice = createSlice({
  name: 'dagpacketProducts',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    getApprovedItem: (state, action) => {
      const item = action.payload;
      state.itemApproved = item;
    },

    resetApprovedItem: (state) => {
      state.itemApproved = null;
    },

    getAlmacenId: (state, action) => {
      const id = action.payload;
      state.almacenId = id;
    },

    addCart: (state, action) => {
      const product = action.payload;
      // const isEmptyCart = state.checkout.cart.length === 0;
      state.cartProducts = [...state.cartProducts, product];

      // slice.reducers.calcSubtotal();

      // ---local storage
      // localStorage.setItem('cartProducts', JSON.stringify(state.cartProducts));
    },

    removeItem: (state, action) => {
      const id = action.payload;
      const newCart = state.cartProducts.filter((item) => item.idProducto !== id);
      state.cartProducts = newCart;

      // ---local storage
      // localStorage.setItem('cartProducts', JSON.stringify(state.cartProducts));
    },

    calcSubtotal: (state) => {
      let subTotal = 0;
      let utilityTotal = 0;

      state.cartProducts.map((item) => (subTotal += parseFloat(item.price_complete)));
      state.cartProducts.map((item) => (utilityTotal += parseFloat(item.utlity)));

      state.subtotalProducts = subTotal;
      state.totalProducts = subTotal;
      state.utilityTotal = utilityTotal;
      state.utilityDag = Number((utilityTotal * 0.3).toFixed(2));
      state.utilityLicen = Number((utilityTotal * 0.7).toFixed(2));
    },

    updateCartProductsItem: (state, action) => {
      const obj = action.payload;
      const id = obj.object_id;
      const newArr = state.cartProducts.filter((item) => item.object_id !== id);
      state.cartProducts = [...newArr, obj];

      // ---local storage
      // localStorage.setItem('cartProducts', JSON.stringify(state.cartProducts));
    },

    resetCartProducts: (state) => {
      state.cartProducts = [];
      state.subtotalProducts = 0;
      state.totalProducts = 0;

      // ---local storage
      // localStorage.setItem('cartProducts', JSON.stringify(state.cartProducts));
    },

    restartCartProducts: (state, action) => {
      const itemsList = action.payload ? action.payload : [];
      state.cartProducts = itemsList;
      state.subtotal = 0;
      state.total = 0;

      // // ---local storage
      // localStorage.setItem('cart', JSON.stringify(state.checkout.cart));
    },

    // steps

    resetActiveStepProducts(state) {
      state.activeStepProducts = 0;
    },
    onBackStepProducts(state) {
      state.activeStepProducts -= 1;
    },

    onNextStepProducts(state) {
      state.activeStepProducts += 1;
    },

    // items error - success

    setItemsSuccessProducts: (state, action) => {
      const id = action.payload;
      state.itemsSuccess = [...state.itemsSuccess, id];
    },
    setItemsErrorProducts: (state, action) => {
      const id = action.payload;
      state.itemsError = [...state.itemsError, id];
    },

    resetItemsSuccessProducts: (state) => {
      state.itemsSuccess = [];
    },
    resetItemsErrorProducts: (state) => {
      state.itemsError = [];
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  resetActiveStepProducts,
  onBackStepProducts,
  onNextStepProducts,
  resetCartProducts,
  setItemsSuccessProducts,
  setItemsErrorProducts,
  resetItemsSuccessProducts,
  resetItemsErrorProducts,
  updateCartProductsItem,
  getAlmacenId,
  getApprovedItem,
  resetApprovedItem
} = slice.actions;

// ----------------------------------------------------------------------

export const addCartProducts = (item) => (dispatch) => {
  dispatch(slice.actions.addCart(item));
  dispatch(slice.actions.calcSubtotal());
};

export const removeItemProducts = (id) => (dispatch) => {
  dispatch(slice.actions.removeItem(id));
  dispatch(slice.actions.calcSubtotal());
};

export const restartCartProducts = (item) => (dispatch) => {
  dispatch(slice.actions.restartCartProducts(item));
  dispatch(slice.actions.calcSubtotal());
};
